export default __webpack_public_path__ + "maps-guides-view-annotation-marker-popup-1200-a9d5b09cd8ca4f2e7043690ba7cec22e.webp";